<template>
    <div>
        <input type="file" :id="id" ref="fileInput" :accept="accept" @change="handleFileUpload" multiple style="display: none"/>

        <div class="d-flex flex-column gap-3">
            <template v-for="(file, index) in files">
                <div :key="file.name" class="d-flex justify-content-between align-items-center border file gap-3">
                    <div class="d-flex gap-1 text-muted fw-500 fs-5" style="min-width: 0">
                        <div class="text-truncate" :title="getName(file)" style="flex: 1 1 0">
                            {{file.name}}
                        </div>
                        <div>
                            ({{file.size}}MB)
                        </div>
                    </div>

                    <button type="button" class="text-dark btn-clear" style="font-size: 18px" aria-label="Close" @click="removeFile(index)">
                        <i class="las la-times"></i>
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: ['id', 'files', 'accept'],
    methods: {
        handleFileUpload() {
            for (let i = 0; i < this.$refs.fileInput.files.length; i++) {
                const file = this.$refs.fileInput.files[i];

                if (file) {
                    const reader = new FileReader();
                    const extension = file.name.split('.').pop().toLowerCase();

                    if (!this.accept.includes(extension)) {
                        return;
                    }

                    const sizeInMB = (file.size / (1024 * 1024)).toFixed(2);

                    reader.onload = (e) => {
                        this.files.push({
                            name: file.name,
                            type: file.type,
                            url: e.target.result,
                            extension: extension,
                            size: sizeInMB
                        });
                    };

                    reader.readAsDataURL(file);
                }
            }
        },
        removeFile(index) {
            this.files.splice(index, 1);
        },
        getName(file) {
            return `${file.name} (${file.size}MB)`;
        }
    }
};
</script>

<style lang="scss" scoped>
    .file {
        padding: 10px 14px;
    }
</style>
